var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42871 0.849609C4.34408 0.849609 4.26432 0.865885 4.18945 0.898438C4.11458 0.93099 4.04622 0.979818 3.98438 1.04492L0.268555 4.84863C0.157878 4.95931 0.102539 5.09115 0.102539 5.24414C0.102539 5.35156 0.128581 5.44922 0.180664 5.53711C0.229492 5.625 0.296224 5.69336 0.380859 5.74219C0.465495 5.79427 0.561523 5.82031 0.668945 5.82031C0.825195 5.82031 0.961914 5.76172 1.0791 5.64453L4.66309 1.96777H4.18945L7.77832 5.64453C7.89551 5.76172 8.03223 5.82031 8.18848 5.82031C8.2959 5.82031 8.39193 5.79427 8.47656 5.74219C8.5612 5.69336 8.62956 5.625 8.68164 5.53711C8.73047 5.44922 8.75488 5.35156 8.75488 5.24414C8.75488 5.16602 8.74186 5.09277 8.71582 5.02441C8.68652 4.95931 8.64421 4.90072 8.58887 4.84863L4.87305 1.04492C4.73958 0.914714 4.59147 0.849609 4.42871 0.849609Z",
    fill: "#9F9F9F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.50cc2c1f52d176e841a1e82ec329b54f.svg";
export { ForwardRef as ReactComponent };